<template>
  <div :style="getElementStyle">
    <div v-if="!isDefalutPosq" style="display: flex">
      <div>
        <label for="text" style="margin-right: 5px">{{ data.label }}</label>
        <span
          v-if="data.validations.required"
          style="color: red; font-weight: bold; margin-left: 5px"
        >
          *
        </span>
        <i
          class="el-icon-copy-document"
          v-if="!isDataTableField"
          @click="copyDocument"
        ></i>
        <span v-if="data.description" style="margin-right: 5px">
          <i class="el-icon-info" :title="data.description"></i>
        </span>
      </div>
      <el-col>
        {{ form[data.key] }}
        <span v-if="isActive" class="setting-icon" @click="openSettings">
          <i class="el-icon-s-tools" />
        </span>
      </el-col>
    </div>

    <el-row align="middle" v-else>
      <el-col
        :span="showLabel && !isDefalutPosq ? 4 : data.description ? 20 : 24"
        :style="computedStyles"
      >
        <label for="text" style="margin-right: 5px">{{ data.label }}</label>
        <span
          v-if="data.validations.required"
          style="color: red; font-weight: bold"
        >
          *
        </span>
        <i
          class="el-icon-copy-document"
          v-if="!isDataTableField"
          @click="copyDocument"
        ></i>
        <span>
          <el-popover
            v-if="data.description"
            placement="top-start"
            trigger="hover"
            :content="data.description"
          >
            <i class="el-icon-info" slot="reference"></i>
          </el-popover>
        </span>
      </el-col>
      <el-col :span="showLabel && !isDefalutPosq ? 12 : 24">
        <div v-if="!isView">
          <el-input
            v-model="selectedValue"
            :placeholder="data.placeholder"
            :style="getStyle"
          />
          <span
            v-if="isActive || isDataTableField"
            class="setting-icon"
            @click="openSettings"
          >
            <i class="el-icon-s-tools" />
          </span>
        </div>
        <div v-else>
          {{ form[selectedValue] }}
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: [
    "data",
    "value",
    "form",
    "isView",
    "isActive",
    "isDataTableField",
    "isInDataTable",
    "labelAlignments",
  ],
  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    computedStyles() {
      const styles = {};
      styles.display = "flex";
      if (this.labelAlignments || this.data?.styles?.labelAlignments) {
        styles.justifyContent =
          this.labelAlignments || this.data?.styles?.labelAlignments;
      }
      return styles;
    },
    getStyle() {
      return `height:${this.data.height - 30}px; width: 100%;`;
    },
    getElementStyle() {
      let borderStyle = "";
      if (this.data.styles) {
        const {
          border_type,
          border_size,
          border_color,
          background,
          label_color,
          font,
        } = this.data.styles;
        let type = border_type || "solid";
        let size = border_size ? border_size + "px" : "0px";
        let color = border_color || "";
        let font_size = font?.font_size || 14;
        let bold = font?.style === 1 || font?.style === 3 ? "bold" : "";
        let italic = font?.style === 2 || font?.style === 3 ? "italic" : "";

        borderStyle += `border:${type} ${size} ${color};`;
        if (background) borderStyle += `background:${background};`;
        borderStyle += `font-size:${font_size}px;`;
        if (bold) borderStyle += `font-weight:${bold};`;
        if (italic) borderStyle += `font-style:${italic};`;
        if (label_color) borderStyle += `color:${label_color};`;
      }
      return borderStyle;
    },
    isDefalutPosq() {
      return !(this.data.styles && this.data.styles.labelStyle === "right");
    },
  },
  data() {
    return {
      showLabel: true,
    };
  },
  mounted() {
    if (this.data.styles?.labelStyle === "hide") {
      this.showLabel = false;
    }
  },
  methods: {
    copyDocument() {
      this.$emit("copy-document", this.data.key);
    },
    openSettings() {
      this.$emit("settings");
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input-number {
  width: 100% !important;

  .el-input,
  .el-input__inner {
    height: inherit !important;
  }
}
</style>
